import React from "react";
import g from "glamorous";
import { css } from "glamor";
import { NavLink, BrowserRouter, Switch, Route } from "react-router-dom";
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faTwitter } from '@fortawesome/fontawesome-free-brands';
import { faTelegramPlane} from '@fortawesome/fontawesome-free-brands';
import { faRedditAlien} from '@fortawesome/fontawesome-free-brands';

const PostMeta = g.p({
  letterSpacing: '-0.02em',
  fontWeight: '400',
  fontStyle: 'normal',
  verticalAlign: 'baseline',
  textRendering: 'auto',
  lineHeight: '1.3',
  paddingBottom: '5px',
  display: 'block',
  fontSize: '14px',
  color: 'rgba(0,0,0,0.3)',
  marginBottom: '15px',
  fontFamily: 'sans-serif',
})

const PostTitle = g.h1({
  color: 'rgba(0,0,0,0.8) !important',
  letterSpacing: '-0.02em',
  fontWeight: 700,
  fontStyle: 'normal',
  marginBottom: '15px',
  fontFamily: 'sans-serif',
})

const PostContent = g.article({
  display: 'block',
  margin: '2px 0 0',
  fontSize: '18px',
  lineHeight: '1.58',
  letterSpacing: '-0.003em',
  fontFamily: '"PT Serif"',
  fontStyle: 'normal',
  fontWeight: 400,
})

const NavDiv = g.div({
  minHeight: '40px;',
  paddingTop: '5px'
})

const NavPrev = g(NavLink)({
  float: "left"
})

const NavNext = g(NavLink)({
  float: "right"
})

const FooterDiv = g.div({
  marginTop: '35px',
  marginBottom: '33px',
  paddingTop: '35px',
  paddingRight: '0px',
  paddingBottom: '33px',
  paddingLeft: '0px',
  borderTopColor: 'rgba(0,0,0,0.1)',
  borderTopWidth: '1px',
  borderTopStyle: 'solid',
  maxHeight: '25px !important',
})

const TwitterBtn = g.a({
  color: 'rgba(0,0,0,.68) !important',
  backgroundImage: 'none !important',
  marginRight: '8px',
  float: 'right',
})

const TelegramBtn = g.a({
  color: 'rgba(0,0,0,.68) !important',
  backgroundImage: 'none !important',
  marginRight: '8px',
  float: 'right',
})

const RedditBtn = g.a({
  color: 'rgba(0,0,0,.68) !important',
  backgroundImage: 'none !important',
  marginRight: '8px',
  float: 'right',
})

export default function Template({ data, pathContext, location }) {
  const post = data.markdownRemark;
  const { next, prev } = pathContext;
  return (
    <g.Div>
      <PostTitle>{post.frontmatter.title}</PostTitle>
        <PostMeta>
          <g.Span>{post.frontmatter.date}</g.Span>
          <g.Span css={{ paddingRight: '.45em', paddingLeft: '.45em' }}>·</g.Span>
          <g.Span>{post.timeToRead} mins read</g.Span>
        </PostMeta>
      <PostContent dangerouslySetInnerHTML={{ __html: post.html }}>
      </PostContent>
       <FooterDiv>
          <TwitterBtn href={"https://twitter.com/intent/tweet?text=" + post.frontmatter.title + "&url=" + process.env.BASE_URL + location.pathname} >
            <FontAwesomeIcon icon={faTwitter} size="lg" />
          </TwitterBtn>
       </FooterDiv>
    </g.Div>
  );
};

export const query = graphql`
  query BlogPostQuery($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      html
      timeToRead
      frontmatter {
        title
        date(formatString: "DD MMMM, YYYY")
      }
      fields {
        slug
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/blog-post.js